//export const API_URL="http://localhost:8080/"
export const API_URL = "https://dev-atletica-cernusco-api-25-1023068824720.europe-west1.run.app/"// 2025

//export const API_URL = "https://dev-atletica-cernusco-api-25-jgmusahvqq-ew.a.run.app/"// 2024
//export const API_URL="https://matilde-api-dev.plesh.co/"
//export const API_URL="https://dev-atletica-cernusco-api-23-jgmusahvqq-ew.a.run.app/" // 2023

export const currentSeason = "2025"